/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaContactUsFormData } from './aaa_contact-us-form.data';
import { IAaa_contactUsFormProps } from './aaa_contact-us-form.props.autogenerated';
import { contactusAsync } from '../../dataActions/DataActionExtension.g';

export interface IAaa_contactUsFormViewProps extends IAaa_contactUsFormProps<IAaaContactUsFormData> {
    setFromField: any;
    onSubmit: any;
    state: any;
}

/**
 *
 * Aaa_contactUsForm component
 * @extends {React.PureComponent<IAaa_contactUsFormProps<IAaaContactUsFormData>>}
 */
class Aaa_contactUsForm extends React.PureComponent<IAaa_contactUsFormProps<IAaaContactUsFormData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            boutiqueName: '',
            boutiqueLocation: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            description: ''
        };
    }
    private setFromField = (field: string, value: string) => {
        this.setState({ [field]: value });
    };
    private onSubmit = async () => {
        const payload = {
            BoutiqueName: this.state.boutiqueName,
            BoutiqueLocation: this.state.boutiqueLocation,
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            Email: this.state.email,
            Phone: this.state.phone,
            Description: this.state.description,
            Mobile: '',
            ReasonForContact: ''
        };
        await contactusAsync({ callerContext: this.props.context.actionContext, queryResultSettings: {} }, payload);
        this.setState({ boutiqueName: '', boutiqueLocation: '', firstName: '', lastName: '', phone: '', email: '', description: '' });
    };
    public render(): JSX.Element | null {
        const viewProps: IAaa_contactUsFormViewProps = {
            ...(this.props as IAaa_contactUsFormProps<IAaaContactUsFormData>),
            setFromField: this.setFromField,
            state: this.state,
            onSubmit: this.onSubmit
        };
        return this.props.renderView(viewProps);
    }
}

export default Aaa_contactUsForm;
